<template>
  <div
    class="mx-2 mb-2 px-4 py-3 hover:bg-gray-50 rounded-lg cursor-pointer flex items-center justify-between group transition-all border border-transparent hover:border-blue/20"
    @click="$emit('click')"
  >
    <div class="flex items-center gap-3">
      <!-- Icon container -->
      <div
        class="flex-shrink-0 size-10 bg-[#E0EDFF] text-blue rounded-lg flex items-center justify-center group-hover:bg-blue group-hover:text-white transition-all border border-blue/20"
      >
        <TargetIcon class="size-5" />
      </div>

      <!-- Text -->
      <div>
        <div
          class="text-sm font-bold transition-colors text-gray-900 group-hover:text-blue line-clamp-2"
          v-html="renderedTitle"
        ></div>

        <div class="flex flex-wrap items-center gap-2 text-gray-500 mt-1.5">
          <span
            v-if="props.catLabel"
            class="text-xs font-bold text-gray-700 bg-gray-100 px-2 py-1 rounded-md border border-gray-200"
          >
            {{ props.catLabel }}
          </span>
        </div>
      </div>
    </div>

    <!-- Arrow -->
    <ChevronRight
      class="size-5 text-gray-300 transition-colors group-hover:text-blue"
    />
  </div>
</template>

<script setup>
import { ChevronRight, TargetIcon } from 'lucide-vue-next';
import { renderLatexToHtml } from '@/utils/katex';

const props = defineProps({
  title: { type: String, required: true },
  catLabel: { type: String, default: '' },
});

const renderedTitle = computed(() => {
  if (!props.title) return '';
  // Convert $...$ inline and $$...$$ display delimiters to \(...\) / \[...\]
  const converted = props.title
    .replace(/\$\$([^$]+)\$\$/g, '\\[$1\\]')
    .replace(/\$([^$\n]+)\$/g, '\\($1\\)');
  return renderLatexToHtml(converted);
});
</script>
